import { render, staticRenderFns } from "./MakeReservationDocumentStep.vue?vue&type=template&id=517538a4&scoped=true&"
import script from "./MakeReservationDocumentStep.vue?vue&type=script&lang=js&"
export * from "./MakeReservationDocumentStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517538a4",
  null
  
)

export default component.exports